export default __webpack_public_path__ + "static/movie-e7861ad9c0b9a7db5022ee84a1161b3f.png";